(function(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(function() {
    /*********** accordion *********/
    var accordions = document.querySelectorAll('.accordion'),
        details;

    [].forEach.call(accordions, function(accordion) {
        details = accordion.querySelectorAll('details');

        [].forEach.call(details, function(elem) {
            var inner = elem.querySelector('.inner'),
                summary = elem.querySelector('summary');

            summary.addEventListener('click', function(e) {
                e.preventDefault();

                if (elem.getAttribute('open')) {
                    elem.removeAttribute('open');
                    inner.style.display = 'none';
                } else {
                    elem.setAttribute('open', true);
                    inner.style.display = 'block';
                }
            });
        });
    });
});